export const ALLOW_CLIENT_LIST = ["cdphp"];
export const ALLOW_FORMULARY_LIST: {[key: string]: string} = {
  freedom: "https://caprx.adaptiverx.com/webSearch/index?key=8F02B26A288102C27BAC82D14C006C6FC54D480F80409B68F7175D0DC1577226",
  liberty: "https://caprx.adaptiverx.com/webSearch/index?key=8F02B26A288102C27BAC82D14C006C6FC54D480F80409B6860374AA7ED985B45",
};
